export default __webpack_public_path__ + "static/media/Closing.04b2885c.svg";